// require("@babel/polyfill");
window.$ = require('jquery')
require('moment')
require('./moment-locale-fr.js')

require('./bower_components/bootstrap/dist/js/bootstrap.min')
// removed from here as it causes a strange error at bootstrap time when (soft) reloading the page
// require('./lib/angular-growl.css')

require('angular')
require('angular-i18n/angular-locale_fr')
require("exports-loader?'classy'!angular-classy");
require('simplebar/dist/simplebar')
require('simplebar/dist/simplebar.css')
import './ngvue.js';

// required by angular-google-maps-native
angular.lowercase = function(text){
	return text.toLowerCase();
}
var app = angular.module('eatself', [
	'ngVue',
	require('angular-ui-router/release/angular-ui-router.js'),
	'classy',
	require("exports-loader?'ui.mask'!angular-ui-mask/dist/mask.min"),
	require("exports-loader?'ngCookies'!angular-cookies/angular-cookies.min"),
	require("exports-loader?'ngTouch'!angular-touch/angular-touch.min"),
	require("exports-loader?'ngAnimate'!angular-animate/angular-animate.min"),
	require("exports-loader?'ngAutocomplete'!ngAutocomplete"),
	// require("exports-loader?'GoogleMapsNative'!angular-google-maps-native/dist/angular-google-maps-native.js"),
	require("exports-loader?'GoogleMapsNative'!angular-google-maps-native/dist/angular-google-maps-native.min"),
	require("exports-loader?'ngSanitize'!angular-sanitize/angular-sanitize.min"),
	require("exports-loader?'validation.match'!angular-validation-match"),
	require("exports-loader?'angular-growl'!./lib/angular-growl"),
	require("exports-loader?'ui.bootstrap'!angular-bootstrap/ui-bootstrap-tpls.min"),
	require("exports-loader?'720kb.socialshare'!angular-socialshare/dist/angular-socialshare.min"),
	require("exports-loader?'ui.router.title'!angular-ui-router-title"),
])
require('./es6-modules-angular-wrapper.ts');
let a = 3;
// app config
require('./eatself-config');
require('./eatself-routes');

// load application-wide services, directives and filters
require('./auth/authorization-service')
require('./services/ui-service')
require('./services/option-category-service');
require('./services/getresto-service');

require('./directives/confirm-popover-directive')
require('./directives/triggerable-tooltip-directive')
require('./directives/ui-sref-if-directive')
require('./directives/relative-width-directive')
require('./directives/ensure-margin-bottom-equals-directive')
require('./directives/one-line-directive')
require('./directives/popover-toggler-directive')
require('./directives/on-error-src-directive')
require('./directives/image-scale-directive')
// require('./directives/textarea-auto-resize-directive')
require('./directives/responsive-class-directive')

var ctx = require.context("./filters", true, /.(js|es6)$/)
ctx.keys().forEach(ctx)

require('./services/ticket-service')
require('./services/backup-service')
require('./services/theme-service')
require('./services/stuart-service')
require('./services/uibmodal-service.es6')

var ctx = require.context("./checkout", true, /.(ts|js|es6)$/)
ctx.keys().forEach(ctx)


// design v2 components
require('./layout/angular-app')
require('./layout/structured-data-controller')

// design v2 pages
// require('./home/home')
// new designer assets
require('./_design_files/css/bootstrap.css') // bootstrap 3
// require('bootstrap/dist/css/bootstrap.css') // bootstrap 4
require('./_design_files/scss/style1.scss')
require('./_design_files/scss/dark-mode.scss')
require('owl.carousel/dist/owl.carousel.min')
require('owl.carousel/dist/assets/owl.carousel.min.css')
require('owl.carousel/dist/assets/owl.theme.default.min.css')
require('./layout/main')
require('./app.scss')
require('javascript-detect-element-resize')
var ctx = require.context("./components", true, /.(js|es6)$/)
ctx.keys().forEach(ctx)
var ctx = require.context("./services", true, /.(js|es6|ts)$/)
ctx.keys().forEach(ctx)
